import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { ShellService } from '@mynexus/mfe-core';
import { ENotification } from '@app/core/model/e-Notification';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ENotificationBaseReportService {

  protected readonly apiUrl: string;
  protected readonly httpClient: HttpClient;
  constructor(
    http: HttpClient,
    shellService: ShellService,
    @Inject('stream') private readonly stream: string
  ) {
    this.apiUrl = shellService.getBaseUrlFor();
    this.httpClient = http;
  }

  getENotificationReport(tenantId:string, authorizationByProductId: string): Observable<ENotification[]> {
    const Url = `${this.apiUrl}/tenants/${tenantId}/authorizations/${authorizationByProductId}/Enotification/GetENotifications`;
    return this.httpClient.get<ENotification[]>(Url);
  }
}
